
import React from "react"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

import Layout from "../src/components/Layout"
import Post from "../src/components/Post"
import { useSiteMetadata } from '../src/hooks'

import SEO from "../src/components/seo"





const Image = () => {
    const data = useStaticQuery(graphql`
      query {
            
    t0: file( absolutePath: {regex: "/pub/pages\/gatsby-astronaut.png$/"}) {
        childImageSharp {
             fluid(maxWidth: 1024) {
                ...GatsbyImageSharpFluid
                presentationWidth
              }

          }
        publicURL
        ext
 }

      }
      `)
      const NonStretchedImage = props => {
        let normalizedProps = props
        if (props.fluid && props.fluid.presentationWidth) {
          normalizedProps = {
            ...props,
            style: {
              ...(props.style || {}),
              maxWidth: props.fluid.presentationWidth,
              margin: "0 auto", // Used to center the image
            },
          }
         }
         return <Img {...normalizedProps}/>
      }
    // console.log({data:data.placeholderImage})
    return { 
        
    t0: data['t0'].childImageSharp ? NonStretchedImage(data['t0'].childImageSharp) : <img src={ data['t0'].publicURL }/>, // t0: <Img fluid={data['t0'].childImageSharp.fluid} />, 
    t0_: data['t0'].publicURL,
    
     }
  }

const postTitle = `✌️About page
`

const SecondPage = ({pageContext}) => {
  const { title: siteTitle, subtitle: siteSubtitle } = useSiteMetadata();
  const { item } = pageContext
  return <Layout title={`${postTitle} - ${siteTitle}`} socialImage={Image().t0_}>
    <SEO title={postTitle} />
    <Post PUBDATE={item.PUBDATE} title={postTitle} >
    <h2>Check this text! </h2><p>Sources if this page is here: <a href="https://github.com/zag/gatsby-starter-pod6">https:&#x2F;&#x2F;github.com&#x2F;zag&#x2F;gatsby-starter-pod6</a> </p><p>Use a <code>for</code> loop instead.<sup id="fnref:1" class="footnote"><a href="#fn:1">[1]</a></sup> Preferably with an explicit iterator variable. </p><p>Options <strong>are</strong>: </p><ul><li><p>Animal </p></li><ul><li><p><em>Vertebrate</em> </p></li><li><p><strong>Invertebrate</strong> </p></li></ul></ul>{Image().t0}<div class="footnotes"><p><sup id="fn:1" class="footnote"><a href="#fnref:1">[1]</a></sup> The Raku <code>for</code> loop is far more powerful than its Perl 5 predecessor.</p></div>
    </Post>
  </Layout>
}

export default SecondPage
